import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const AuxiloLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. What is the maximum loan amount available through an Auxilo education loan?",
            content: "The maximum loan amount for students is INR 65 lakh for unsecured loans and INR 1 crore for secured loans through Auxilio."
        },
        {
            title: "2. Do we need to make payments for the Auxilo education loan while in the study period?",
            content: "While studying, it is important to pay simple or partial interest. After completing the course or finding employment (whichever comes first), students can begin repaying the initial amount after a 6-month grace period."
        },
        {
            title: "3. What are the interest rates for Auxilo education loans?",
            content: "The interest rate for Auxilo education loans can range from 11.5% to 13.5% per annum. The specific interest rate is determined based on individual profiles."
        },
        {
            title: "4. How long does it take for Auxilo to process an education loan for studying abroad?",
            content: "The processing time for an education loan from Auxilo is 5 working days."
        }, {
            title: "5. Which countries are covered by Auxilo for education loans for overseas education?",
            content: "Auxilo provides loans for studying abroad in countries such as the UK, the US, Germany, France, Canada, Australia, New Zealand, and Ireland."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"Auxilo Education Loan"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"Auxilo Education Loan"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">Auxilo Education Loan for Abroad Studies</h5>
                            <p className="loan-elegibility-des">Founded in 2017, Auxilo Finserve Pvt. Ltd. operates as a Non-Banking Financial Company (NBFC). The company evaluates students using over 15 criteria and provides tailor-made education loan solutions for various countries including the UK, US, Australia, Canada, Germany, France, New Zealand, and Ireland. Auxilo specializes in providing personalized loan options that cater to the specific requirements of each student. Based on your academic background, GyanDhan may also assist you in obtaining an Auxilo education loan for studying overseas even before acknowledgment.</p>
                            <h5 className="about-head">Overview of the Auxilo Education Loan</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Description	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            11.5% - 13.5%

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">

                                            Up to INR 65 Lakh

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Moratorium period</td>
                                        <td className="">

                                            Course duration + 1-year

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Margin money</td>

                                        <td className="">nil</td>

                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing fees</td>
                                        <td className="">

                                            0.5-1.5%

                                        </td>


                                    </tr>
                                    <tr>
                                        <td>Processing time</td>
                                        <td>7-10 days</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Repayment tenure</td>
                                        <td>15 years</td></tr>

                                </tbody>
                            </table>



                            <h5 className="about-head mb-4">Age</h5>
                            <p className="loan-elegibility-des">To apply, individuals must be at least 18 years old. They should also have received admission to a reputable university.</p>
                            <h5 className="about-head">Academic Performance</h5>
                            <p className="loan-elegibility-des">The applicant must regularly maintain good academic standing and fulfill Auxilo’s basic academic requirements to be eligible for an education loan. Furthermore, the student might be required to complete specific exams like IELTS, GRE, or TOEFL. It is essential to remember that, in the United States, GRE scores are particularly vital for obtaining financial assistance through a student loan for education.</p>
                            <h5 className="about-head">Co-applicant</h5>
                            <p className="loan-elegibility-des">The borrower needs to have a co-applicant for the application. This co-applicant could be someone like the applicant’s mother, father, sister, brother, spouse, relative from either side of the family, or a legal guardian. They must have a reliable source of income and a good credit history.</p>
                            <h5 className="about-head">Course and Country of Study</h5>
                            <p>This program will cover standard graduate and post-graduate degrees, diplomas, certificates, and doctorate courses in various fields provided by international universities in countries like the USA, UK, Canada, Australia, New Zealand, France, Germany, and Ireland. This program will cover standard graduate and post-graduate degrees, diplomas, certificates, and doctorate courses in various fields provided by international universities in countries like the UK, Canada, USA, Australia, France, New Zealand, Germany, and Ireland.</p>


                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">
                            <h5 className="about-head">Auxilo Education Loan for US</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>GRE &gt;=310	</th>
                                        <th>GRE 300 - &lt; 310</th>
                                        <th>GRE 285 - &lt; 299</th>

                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            11.25 - 11.75%

                                        </td>
                                        <td className="">11.75 - 12.5%</td>
                                        <td>12.5 - 13%</td>

                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">

                                            Up to INR 65 Lakh

                                        </td>
                                        <td className="">Up to INR 50 Lakh</td>
                                        <td>Up to INR 40 Lakh</td>

                                    </tr>
                                    <tr>
                                        <td className="">
                                            Co-applicant minimum income</td>
                                        <td className="">

                                            INR 30K

                                        </td>
                                        <td className="">INR 35K</td>
                                        <td>INR 35K</td>

                                    </tr>
                                    <tr>
                                        <td className="">
                                            Monthly installment during the course</td>

                                        <td className="">Partial simple interest</td>
                                        <td>Partial simple interest</td>
                                        <td>Simple interest</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing fees</td>
                                        <td className="">

                                            0.5-1%

                                        </td>

                                        <td>0.7 - 1%</td>
                                        <td className="">1%</td>

                                    </tr>

                                </tbody>
                            </table>
                            <h5 className="about-head">Auxilo Education Loans for Other Countries</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Australia / New Zealand</th>
                                        <th>Canada</th>
                                        <th>UK</th>
                                        <th>Germany/Ireland/France/Italy</th>
                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            12.5 - 14%

                                        </td>
                                        <td className="">12 - 13%</td>
                                        <td>12.5 - 13.5%</td>
                                        <td>12.5 - 13.5%</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">

                                            INR 20 Lakh

                                        </td>
                                        <td className="">INR 30 Lakh</td>
                                        <td>INR 40 Lakh</td>
                                        <td>INR 20 Lakh</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Co-applicant minimum income</td>
                                        <td className="">

                                            INR 60K

                                        </td>
                                        <td className="">INR 30K</td>
                                        <td>INR 40K</td>
                                        <td>INR 40K</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Monthly installment during the course</td>
                                        <td className="">

                                            EMI

                                        </td>
                                        <td className="">Simple interest</td>
                                        <td>Simple interest</td>
                                        <td>Simple interest</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing fees</td>
                                        <td className="">

                                            1 - 1.5%

                                        </td>
                                        <td className="">1%</td>
                                        <td>1 - 2%</td>
                                        <td>1 - 1.5%</td>
                                    </tr>

                                </tbody>
                            </table>
                            <h5 className="about-head">Auxilo's List of Necessary Documents for Education Loan</h5>
                            <p className="loan-elegibility-des">Credere provides a personalized list of documents required for Auxilo education loans. The list is tailored based on your profile, your co-applicant’s profile, and any property or asset that you may provide as collateral.</p>
                            <h5 className="about-head">Applicant's Documents</h5>
                            <ol className="subhead-ul">
                                <li>Address proof: recent copy of electricity bill/water bill/ telephone bill/ piped gas bill/ driving license/ Aadhaar card</li>
                                <li>Education loan application form</li>
                                <li>Identity verification includes a PAN, passport, driver's license, voter ID card, or other government-issued identity document</li>
                                <li>Past academic record</li>
                                <li>10th standard mark sheet</li>
                                <li>12th standard mark sheet</li>
                                <li>Undergraduate result (semester-wise)</li>
                                <li>Passport</li>
                                <li>Entrance exam results (e.g. GMAT, GRE, TOEFL, etc.)</li>
                                <li>Statement of expenses</li>
                                <li>Document/proof of admission: admission letter (conditional admission letter is also acceptable).</li>
                            </ol>
                            <h5 className="about-head">Co-applicant's Documents</h5>

                            <ol className="subhead-ul">
                                <li>Address: recent copy of water bill/ telephone bill/ electricity bill/ piped gas bill or copy of passport/Aadhaar card/ driving license</li>
                                <li>Identity proof: PAN / Driver’s license/ Passport /Voter ID card or government-issued identification document</li>
                                <li>Bank account statement of the co-borrower/guarantor for the previous six months (in the event of an education loan takeover)</li>
                                <li>2 passport-size photographs</li>
                            </ol>
                            <h5 className="about-head">Income Proof for Self-employed Co-applicant/ Guarantor</h5>
                            <ol className="subhead-ul">
                                <li>TDS certificate (Form 16A, if applicable)</li>
                                <li>Certificate of qualification (for C.A./ doctor and other professionals)</li>
                                <li>Business address proof</li>
                                <li>Last two years’ IT returns (if IT Payee)</li>
                                <li>A brief statement of the assets and liabilities of the guardian parent or other co-borrower</li>
                                <li>Bank account statement for the last 6 months</li>
                            </ol>

                            <h5 className="about-head">The Process of Applying for an Auxilo Education Loan via Credere</h5>
                            <p className="loan-elegibility-des">Through their website, applicants may easily complete the basic online application procedure for an education loan from Auxilo. However, for a more streamlined and stress-free application process, try applying for your education loan through Credere. By selecting our services, you can easily get your education loan approved through a simple process.</p>
                            <h6 className="subhead">Procedures for Applying for an Auxilo Education Loan</h6>
                            <p className="loan-elegibility-des">There are several ways that you may contact the customer support team at Auxilo:</p>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th className="text-center">Email</th>
                                        <th className="text-center">Online Application Form</th>
                                        <th className="text-center">Branch Visits</th>
                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            <p className="loan-elegibility-des">Provide detailed information about your profile in an email to <a href="mailto:customercare@auxilo.com"
                                                style={{ textDecoration: "none", color: "var(--primarycolor" }}>customercare@auxilo.com</a>. The team at Auxilo will carefully review your email.</p></td>
                                        <td className="">

                                            <p className="loan-elegibility-des">Visit the Auxilo website at <a href="https://www.auxilo.com/" style={{ textDecoration: "none", color: "var(--primarycolor" }}>www.auxilo.com</a>. Go to the “Contact Us” section of the official site. this section, you will come across an online application form. Take a moment to complete this form by providing your relevant details.</p>
                                        </td>
                                        <td className=""><p className="loan-elegibility-des">Go to the Auxilo branch that is close to you in your town or city. Branch personnel can provide assistance with education loans, including guidance on the application procedure, required paperwork, and any other pertinent information. Auxilo’s headquarters are located in Mumbai, and the company also has offices in Chennai, Delhi, Bengaluru, Hyderabad, Ahmedabad, Pune, and other Indian cities.</p></td>
                                    </tr>

                                </tbody>
                            </table>
                            <p className="loan-elegibility-des">If you would like to apply for an education loan through Credere, an education financing platform that specializes in assisting students in securing funding for their higher education abroad, instead of going through the trouble of visiting physical branches and navigating difficult application forms, you can still use Auxilo to finance your study abroad.
                                <br /><br />
                                Applying through Credere will provide you with an effective solution.
                                <br /><br />
                                After you satisfy the eligibility conditions, one of our professional counselors will carefully analyze your profile and suggest lenders who would suit your unique loan needs. Our counselors will help and assist you along the loan processes, and they are always accessible to answer any questions or deal with any challenges you could run into. </p>
                            <h5 className="about-head mb-4">Advantages of Using Credere to obtain your Auxilo Education Loan</h5>
                            <p className="loan-elegibility-des"><b>Best Loan Guaranteed</b></p>
                            <p className="loan-elegibility-des">Credere strives to deliver you the best education loan available in the market. We work hard to provide you with the greatest offer. We will pay the difference in interest rates for the whole term of your education loan if you find a better deal. </p>
                            <p className="loan-elegibility-des"><b>Quick Processing Time</b></p>
                            <p className="loan-elegibility-des">Credere collaborates closely with several Auxilo departments to make sure that our student loan applications are approved for loans as swiftly as possible, generally in 5-7 days. One of the main reasons students come back to us year after year for assistance with their loan application is our speedy service. However, the typical processing period for a loan application submitted directly to the NBFC can vary between 10 and 12 days.</p>
                            <p className="loan-elegibility-des"><b>100% Free of Cost Services</b></p>
                            <p className="loan-elegibility-des">The services given by Credere to applicants are entirely at no cost. We don’t charge applicants any money at all.</p>
                            <p className="loan-elegibility-des"><b>Higher Probability of Receiving Approval</b></p>
                            <p className="loan-elegibility-des">If there are any difficulties with the paperwork or application, Credere stands in and collaborates with the Auxilo personnel to identify a solution.</p>
                            <p className="loan-elegibility-des"><b>Online Document Submission</b></p>
                            <p className="loan-elegibility-des">With Credere, you can save time and effort by using our online document upload feature. This means you don’t have to make a physical visit to the NBFC to submit your documents. Moreover, we will keep you updated on every stage of the loan approval process through timely notifications.</p>
                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default AuxiloLendingPartner;